import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { hooks as commonHooks } from '@sitebuilder/common';
import { actionCreators } from '../../reducers/media';
import {
    ErrorMessage,
    PrimaryButton,
    SideBarAccordion,
    SpinnerIcon,
    SuccessMessage,
    TextInput,
} from '../BaseComponents';
import { StateShape as ReduxStateShape } from '../../reducers';
import { formNameRegex } from '../../utils';

const nameRegex = formNameRegex;
type FormData = any;

const SaveNewFolderForm = ({ urlState }: { urlState?: string }) => {
    const dispatch = useDispatch();
    const i18n = commonHooks.useLocalization();
    const [accordionActiveKeys, setAccordionActiveKeys] = useState(['']);
    // const fileInputRef = useRef<any>(null);

    const initialData = {
        name: '',
    };
    const [data, setData] = useState<FormData>(initialData);

    // error messages for invalid inputs
    const [dataError, setDataError] = useState<FormData>(initialData);

    // error message on folder save
    const [error, setError] = useState<string>('');

    // success message on folder save
    const [success, setSuccess] = useState<string>('');

    const { newFolderSaveLoading, newFolderSaveSucess, newFolderSaveError } = useSelector(
        (state: ReduxStateShape) => ({
            ...state?.media,
        })
    );

    useEffect(() => {
        if (newFolderSaveSucess) {
            setSuccess(newFolderSaveSucess);
            dispatch(actionCreators.listMedias(urlState || ''));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newFolderSaveSucess]);

    useEffect(() => {
        if (newFolderSaveError) {
            setError(i18n.t('folder_form_save_error'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newFolderSaveError]);

    const onClickAccordion = (eventKey: string) => {
        if (accordionActiveKeys.includes(eventKey)) {
            setAccordionActiveKeys(accordionActiveKeys.filter((k) => k !== eventKey));
        } else if (eventKey) {
            setAccordionActiveKeys([eventKey]);
        }
    };
    const validateFormData = () => {
        let valid = false;
        const { name } = data;
        const err: FormData = {
            name: '',
        };

        if (!name) {
            err.name = i18n.t('form_missing_name');
        }

        if (!_.values(err).every(_.isEmpty)) setDataError({ ...dataError, ...err });

        valid =
            _.every(err, (e) => e === '' || _.isNull(e)) &&
            _.every(dataError, (e) => e === '' || _.isNull(e));
        return valid;
    };

    const handleSubmit = async () => {
        const isFormValid = validateFormData();
        if (isFormValid) {
            // check if folder with the same name exists
            const folder = await dispatch(
                actionCreators.loadMedia(
                    urlState ? `${urlState.substring(1)}/${data.name}` : data.name
                )
            );
            if (!_.isEmpty(folder)) {
                setError(i18n.t('folder_already_exists'));
                setSuccess('');
            } else {
                dispatch(
                    actionCreators.saveNewFolder(
                        urlState ? `${urlState.substring(1)}/${data.name}` : data.name
                    )
                );
                setData(initialData);
                setDataError(initialData);
            }
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
        const { value } = e?.target;

        if (error) {
            setError('');
        }

        if (success) {
            setSuccess('');
        }

        if (!value && dataError[field]) {
            setDataError({ ...dataError, [field]: '' });
        }
        if (field === 'name') {
            if (value) {
                if (nameRegex.test(value))
                    setDataError({ ...dataError, name: i18n.t('form_invalid_name') });
                else if (value.length > 64)
                    setDataError({ ...dataError, name: i18n.t('form_invalid_name_length') });
                else setDataError({ ...dataError, name: '' });
            } else {
                setDataError({ ...dataError, name: i18n.t('form_missing_name') });
            }
        }

        setData({
            ...data,
            [field]: value,
        });
    };

    return (
        <div className="add-new-media-form">
            <hr className="divider" />
            <SideBarAccordion
                toggleTitle={'Create a New Folder'}
                eventKey="0"
                defaultActiveKey="0"
                accordionActiveKey={accordionActiveKeys}
                onClickAccordion={onClickAccordion}
            >
                <div className="save-form">
                    <TextInput
                        className={'form-input'}
                        label={i18n.t('form_name')}
                        inputId={'name-input'}
                        labelId={'name-label'}
                        placeholder={i18n.t('form_name')}
                        value={data.name}
                        onChange={(e) => handleInputChange(e, 'name')}
                        error={dataError.name}
                    />
                    <div className="save">
                        {error && <ErrorMessage error={error} />}
                        {success && <SuccessMessage message={success} />}
                        <PrimaryButton
                            id={'save-button'}
                            className={'save-button'}
                            onClick={handleSubmit}
                        >
                            {newFolderSaveLoading && <SpinnerIcon />}
                            {i18n.t('Create')}
                        </PrimaryButton>
                    </div>
                </div>
            </SideBarAccordion>
        </div>
    );
};

export default SaveNewFolderForm;
